import _ from 'lodash';
import React, { useEffect, useState } from 'react';

import { LOCALSTORAGE_KEYS } from '@/constants';
import Minicart from '@/components/mini-cart';
import { CART_MAXIMUM } from '@/components/mini-cart/constants';
import { getVehicles } from '@/utils/apollo-requests/vehicles/get-vehicles';
import { type HsiycSearchVehiclesRecord } from '@/types/legacy-api/graphql';
import { type Dispatch } from '@/app-state/store';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'vehicleIds' implicitly has an 'any' type.
const addVehicleIdsToLocalStorage = (vehicleIds) => {
  if (vehicleIds && vehicleIds.length) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      try {
        localStorage.setItem(LOCALSTORAGE_KEYS.COMPARE, JSON.stringify(vehicleIds));
      } catch (e) {
        // localStorage is disabled
        console.error('Failed to add vehicle ID to local storage', e);
      }
    }
  }
};

type MiniCartWrapperProps = {
  compareVehicleIds: string[];
  filterActions: Pick<Dispatch['filters'], 'addLifestyle' | 'reset' | 'updateSelectedPriceRange'>;
  isOpen?: boolean;
  onClose: () => void;
  removeFromCompare: Dispatch['compare']['removeFromCompare'];
};

const MiniCartWrapper = ({
  compareVehicleIds = [],
  filterActions,
  isOpen = false,
  onClose,
  removeFromCompare,
}: MiniCartWrapperProps) => {
  const compareVehicleCount = _.size(compareVehicleIds);
  const [VehicleData, setVehicleData] = useState<HsiycSearchVehiclesRecord[]>([]);

  useEffect(() => {
    let isSubscribed = true;

    addVehicleIdsToLocalStorage(compareVehicleIds);

    if (compareVehicleIds) {
      const getCarData = async () => {
        const query = await getVehicles({ vehicleIds: compareVehicleIds });
        if (isSubscribed && typeof query !== 'string') {
          setVehicleData(query.vehicles);
        }
      };
      getCarData();
    }

    return () => {
      isSubscribed = false;
    };
  }, [compareVehicleIds]);

  const vehicles = compareVehicleIds ? VehicleData : [];

  let alertMessage = '';
  if (compareVehicleCount === 1) {
    alertMessage = "There aren't enough cars in your list to compare. Select one more.";
  } else if (compareVehicleCount > CART_MAXIMUM) {
    alertMessage = 'Too many vehicles to compare. The maximum number of vehicles is 6.';
  }

  return (
    <Minicart
      {...{
        filterActions,
        isOpen,
        removeFromCompare,
        vehicles,
        vehicleIds: compareVehicleIds,
        compareVehicleCount,
        onClose,
        alertMessage,
      }}
    />
  );
};

export default MiniCartWrapper;
